export default "/images/64e544ca4877f73a2a9b99668efe69ab.avif";